import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oxd_text, null, {
      default: _withCtx(() => [
        (_ctx.item)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.item,
              target: "_blank"
            }, "Show image", 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "No image"))
      ]),
      _: 1
    })
  ]))
}